/* ==========================================================================
   American Bench Craft – combined accessibility fixes (loop-safe rewrite)
   REPLACES BOTH earlier patches:
     - a11y-remediation-135-157.js
     - a11y-remaining-fixes.js
   Delete both of those from ada-pro.js before loading this file.

   Why the rewrite: the two earlier patches each had a MutationObserver that
   watched class changes on the whole <body> and toggled the same body class
   with opposite results, which ping-ponged forever and froze the page.
   Rules this file follows so that cannot happen again:
     1. Never observe attributes on the whole <body> subtree.
     2. Every observer runs through watch(): batched to one run per frame,
        disconnected while it runs (so it never sees its own writes), and
        paused by a circuit breaker if it ever fires continuously.
     3. Attributes are only written when the value actually changes
        (setAttr / $.fn.abcAttr), so a write never creates a no-op mutation.
     4. The file runs once even if it is included twice.
   Kill switch for debugging: add ?a11y=off to any URL, or run
   localStorage.setItem('abcA11yOff','1') in the console.

   Theme: Motion 10.3.1 ("ADA – 2/12/26 Duplicate Copy Sep 14")
   Load AFTER jQuery and ada-pro.js.
   ========================================================================== */
(function ($) {
  'use strict';
  if (!$ || window.__abcA11yFixes) { return; }
  window.__abcA11yFixes = true;
  try {
    if (/[?&]a11y=off\b/.test(location.search) || localStorage.getItem('abcA11yOff') === '1') { return; }
  } catch (e) { /* storage blocked – continue */ }

  /* ---------- shared helpers ---------------------------------------------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (f) { return setTimeout(f, 16); };

  // Write an attribute only when it changes (a same-value setAttribute still
  // fires a MutationObserver record, which is how the old loops started).
  function setAttr(el, name, value) {
    if (!el) { return; }
    value = String(value);
    if (el.getAttribute(name) !== value) { el.setAttribute(name, value); }
  }
  function rmAttr(el, name) { if (el && el.hasAttribute(name)) { el.removeAttribute(name); } }
  $.fn.abcAttr = function (map) {
    return this.each(function () { for (var k in map) { if (Object.prototype.hasOwnProperty.call(map, k)) { setAttr(this, k, map[k]); } } });
  };

  // Safe observer: one run per animation frame, own writes ignored,
  // circuit breaker pauses the watcher for 2 s if it runs every frame.
  function watch(id, target, opts, fn) {
    if (!target) { return null; }
    var scheduled = false, runs = 0, windowStart = 0, paused = false, mo;
    function run() {
      scheduled = false;
      if (paused) { return; }
      var now = Date.now();
      if (now - windowStart > 1000) { windowStart = now; runs = 0; }
      if (++runs > 40) {
        paused = true;
        if (window.console) { console.warn('[ABC a11y] ' + id + ' paused for 2s (too many DOM updates)'); }
        setTimeout(function () { paused = false; runs = 0; schedule(); }, 2000);
        return;
      }
      mo.disconnect();
      try { fn(); } catch (e) { if (window.console) { console.error('[ABC a11y] ' + id, e); } }
      mo.takeRecords();
      mo.observe(target, opts);
    }
    function schedule() { if (!scheduled) { scheduled = true; raf(run); } }
    mo = new MutationObserver(schedule);
    try { fn(); } catch (e) { if (window.console) { console.error('[ABC a11y] ' + id, e); } }
    mo.observe(target, opts);
    return { schedule: schedule, stop: function () { mo.disconnect(); } };
  }

  if (typeof window.announce !== 'function') {
    if (!document.getElementById('a11y-announcer')) {
      $('body').append('<div id="a11y-announcer" role="status" aria-live="polite" aria-atomic="true" class="visually-hidden"></div>');
    }
    window.announce = function (msg) { var $a = $('#a11y-announcer'); $a.text(''); setTimeout(function () { $a.text(msg); }, 100); };
  }
  function isVisible(el) {
    if (!el) { return false; }
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') { return false; }
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function inViewport(el) {
    if (!isVisible(el)) { return false; }
    var r = el.getBoundingClientRect();
    return r.right > 0 && r.left < window.innerWidth && r.bottom > 0 && r.top < window.innerHeight;
  }
  function setHeadingLevel($h, level) {
    $h.each(function () {
      if (this.tagName.toLowerCase() === 'h' + level) { return; }
      var $new = $('<h' + level + '>').html($(this).html());
      $.each(this.attributes, function () { $new.attr(this.name, this.value); });
      $(this).replaceWith($new);
    });
  }
  function productHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }
  var CART_DIALOG = '[role="dialog"][aria-label="Shopping cart"]';

  /* ========================================================================
     A11Y-018 / A11Y-035  Hover (second) image inside product cards announced.
     ====================================================================== */
  (function fix018() {
    watch('018', document.body, { childList: true, subtree: true }, function () {
      $('.grid-product__link, .grid-product__image-mask').each(function () {
        $(this).find('img').slice(1).abcAttr({ 'aria-hidden': 'true', alt: '' });
      });
    });
  })();

  /* ========================================================================
     A11Y-023  Hero-video section renders with no video. Hide the empty block
     until the video (with captions + transcript) is restored.
     ====================================================================== */
  (function fix023() {
    $('[id^="shopify-section-"][id$="__hero-video"], .video-parent-section').each(function () {
      if (!$(this).find('video, iframe').length && !$.trim($(this).text())) {
        setAttr(this, 'aria-hidden', 'true');
        $(this).addClass('abc-hidden-empty');
      }
    });
  })();

  /* ========================================================================
     A11Y-034  Filter button does not say it opens a dialog.
     ====================================================================== */
  (function fix034() {
    $('#FilterDrawerTrigger, [aria-controls="FilterDrawer"]').abcAttr({ 'aria-haspopup': 'dialog' });
  })();

  /* ========================================================================
     A11Y-040  25 zoom buttons share the name "Zoom product image".
     ====================================================================== */
  (function fix040() {
    var $btns = $('.product__photo-zoom, button[aria-label^="Zoom product image"]');
    var total = $btns.length;
    $btns.each(function (i) {
      var alt = $.trim($(this).closest('.product__photo, [data-index], .product-main-slide').find('img').first().attr('alt') || '');
      alt = alt.replace(/--American Bench Craft.*$/i, '');
      setAttr(this, 'aria-label', 'Zoom product image ' + (i + 1) + ' of ' + total + (alt ? ': ' + alt : ''));
    });
  })();

  /* ========================================================================
     A11Y-041 / A11Y-101 / A11Y-143  Thumbnail strip: Tab from a thumbnail
     dropped focus to <body>; off-screen thumbnails were tabbable.
     The strip is one tab stop (roving tabindex); arrows move inside.
     ====================================================================== */
  (function fix041() {
    var SEL = '.product__thumb-item a';
    var $first = $(SEL).first();
    if (!$first.length) { return; }
    var strip = $first.closest('.product__thumbs, .flickity-enabled')[0] || $first.parent().parent()[0];

    function sync() {
      var $all = $(SEL);
      var $cur = $all.filter('.is-active').first();
      if (!$cur.length) { $cur = $all.first(); }
      $all.each(function () { setAttr(this, 'tabindex', this === $cur[0] ? '0' : '-1'); });
    }
    var w = watch('041', strip, { attributes: true, subtree: true, attributeFilter: ['class'] }, sync);
    $(window).on('load.abc041', function () { if (w) { w.schedule(); } });
    setTimeout(function () { if (w) { w.schedule(); } }, 1000);

    function outside(from, dir) {
      var all = $(FOCUSABLE).filter(function () { return this.offsetParent !== null; }).get();
      var i = all.indexOf(from);
      for (var j = i + dir; j >= 0 && j < all.length; j += dir) {
        if (!strip.contains(all[j])) { return all[j]; }
      }
      return null;
    }
    $(document).on('keydown.abc041', SEL, function (e) {
      var $all = $(SEL), i = $all.index(this), $next = null;
      if (e.key === 'Tab') {
        var target = outside(this, e.shiftKey ? -1 : 1);
        if (target) { e.preventDefault(); e.stopImmediatePropagation(); target.focus(); }
        return;
      }
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { $next = $all.eq(Math.min(i + 1, $all.length - 1)); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { $next = $all.eq(Math.max(i - 1, 0)); }
      else if (e.key === 'Home') { $next = $all.first(); }
      else if (e.key === 'End') { $next = $all.last(); }
      if ($next && $next.length) {
        e.preventDefault();
        $all.each(function () { setAttr(this, 'tabindex', '-1'); });
        setAttr($next[0], 'tabindex', '0');
        $next[0].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        $next.trigger('focus').trigger('click');
      }
    });
    // Safety net: the theme sometimes blurs to <body> after selecting a thumb.
    $(document).on('click.abc041', SEL, function () {
      var el = this;
      setTimeout(function () {
        if (document.activeElement === document.body && document.contains(el)) {
          setAttr(el, 'tabindex', '0');
          el.focus({ preventScroll: true });
        }
      }, 60);
    });
  })();

  /* ========================================================================
     A11Y-045  Cart-drawer upsell stars expose no rating value.
     ====================================================================== */
  (function fix045() {
    watch('045', document.body, { childList: true, subtree: true }, function () {
      $(CART_DIALOG + ' .builder-block').filter(function () {
        return $(this).children('svg').length >= 5 && !this.hasAttribute('data-abc-rating');
      }).each(function () {
        var count = ($(this).parent().text().match(/(\d+)\s*reviews?/i) || [])[1];
        $(this).abcAttr({ role: 'img', 'aria-label': 'Rated 5 out of 5 stars' + (count ? ', ' + count + ' reviews' : ''), 'data-abc-rating': '1' });
      });
    });
  })();

  /* ========================================================================
     A11Y-046 / A11Y-110  Cart-drawer prices unlabelled; 10px review count.
     ====================================================================== */
//   (function fix046() {
//     watch('046', document.body, { childList: true, subtree: true }, function () {
//       var $d = $(CART_DIALOG);
//       if (!$d.length) { return; }
//       $d.find('*').filter(function () {
//         return this.children.length === 0 && /^\$\d[\d,.]*$/.test($.trim(this.textContent)) && !this.hasAttribute('data-abc-price');
//       }).each(function () {
//         var ctx = $(this).closest('.builder-block').parent().text();
//         var label = /subtotal/i.test(ctx) ? 'Subtotal' : (/total/i.test(ctx) ? 'Total' : 'Price');
//         setAttr(this, 'data-abc-price', '1');
//         $(this).prepend('<span class="visually-hidden">' + label + ': </span>');
//       });
//       $d.find('*').filter(function () { return this.children.length === 0 && /^\d+ reviews?$/i.test($.trim(this.textContent)); })
//         .each(function () { if (this.style.fontSize !== '12px') { this.style.fontSize = '12px'; } });
//     });
//   })();

  /* ========================================================================
     A11Y-050 / A11Y-140  "Line 1 (24 Characters)" labels say nothing.
     ====================================================================== */
  (function fix140() {
    var byHandle = {
      'gentlemans-belt': 'Brass plate engraving text',
      'personalized-hunting-collar': 'Dog name',
      'personalized-small-dog-collar': 'Dog name',
      'personalized-martingale-collar': 'Dog name',
      'personalized-standard-collar': 'Dog name'
    };
    var text = byHandle[productHandle()];
    if (!text) { return; }
    $('label[for="product-options-custom-1"]').contents().each(function () {
      if (this.nodeType === 3 && /Line 1 \(\d+ Characters\)/.test(this.nodeValue)) {
        this.nodeValue = this.nodeValue.replace(/Line 1 \((\d+) Characters\)/, text + ' (up to $1 characters)');
      }
    });
  })();

  /* ========================================================================
     A11Y-055  Junip "Write a review" modal sends focus to the header on close.
     Polls only while the modal is open – no observer.
     ====================================================================== */
  (function fix055() {
    $(document).on('click.abc055 keydown.abc055', 'button, [role="button"]', function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') { return; }
      if (!/write a review/i.test($(this).text())) { return; }
      var opener = this, y = window.scrollY, seenOpen = false, ticks = 0;
      var t = setInterval(function () {
        var open = $('.junip-modal').filter(function () { return inViewport(this); }).length > 0;
        if (open) { seenOpen = true; }
        if ((seenOpen && !open) || ++ticks > 2400) {   // stop after ~12 min
          clearInterval(t);
          if (seenOpen && !open) { window.scrollTo({ top: y }); opener.focus(); }
        }
      }, 300);
    });
  })();

  /* ========================================================================
     A11Y-070  YouTube embeds have no transcript / audio description.
     ====================================================================== */
  (function fix070() {
    $('iframe[src*="youtube.com/embed/"]').each(function (i) {
      var id = (this.src.match(/embed\/([^?&\/]+)/) || [])[1];
      if (!id || $(this).next('.a11y-transcript').length) { return; }
      var title = $('<b>').text(this.getAttribute('title') || 'Video ' + (i + 1)).html();
      $(this).after('<details class="a11y-transcript"><summary>Transcript: ' + title + '</summary>' +
        '<p><a href="https://www.youtube.com/watch?v=' + id + '" target="_blank" rel="noopener">Open this video on YouTube (opens in a new tab) and use "Show transcript".</a></p>' +
        '<p class="a11y-transcript__todo">[TODO – paste the full transcript and a description of important visual content here]</p></details>');
    });
  })();

  /* ========================================================================
     A11Y-076  Terms of Service has no section headings.
     ====================================================================== */
  (function fix076() {
    if (!/^\/policies\//.test(location.pathname)) { return; }
    $('#MainContent p, main p, .rte p').filter(function () {
      var t = $.trim($(this).text());
      return t.length < 90 && /^(SECTION\s+\d+|[A-Z][A-Z0-9 ,&\-\/']{6,})$/.test(t) && !$(this).find('a').length;
    }).each(function () { $(this).replaceWith($('<h2 class="h4">').text($.trim($(this).text()))); });
  })();

  /* ========================================================================
     A11Y-087  Junip stars on product cards: 10x "Outline Star", no rating.
     ====================================================================== */
  (function fix087() {
    watch('087', document.body, { childList: true, subtree: true }, function () {
      $('.junip-product-summary-stars-wrapper, .junip-product-summary').each(function () {
        if (this.hasAttribute('data-abc-stars') || this.getAttribute('role') === 'button') { return; }
        var $svgs = $(this).find('svg');
        if (!$svgs.length) { return; }
        var count = ($(this).text().match(/\((\d+)\)/) || [])[1] || '';
        var rating = $(this).attr('data-rating') || $(this).closest('[data-rating]').attr('data-rating') || '';
        $svgs.each(function () { setAttr(this, 'aria-hidden', 'true'); rmAttr(this, 'role'); });
        $svgs.find('title').remove();
        $(this).abcAttr({
          role: 'img',
          'aria-label': (rating ? 'Rated ' + rating + ' out of 5 stars' : 'Star rating') + (count ? ', ' + count + ' reviews' : ''),
          'data-abc-stars': '1'
        });
      });
    });
  })();

  /* ========================================================================
     A11Y-089  Two navigation landmarks named "Primary".
     ====================================================================== */
  (function fix089() {
    $('#NavDrawer [role="navigation"], #NavDrawer nav, ul.mobile-nav[role="navigation"]').abcAttr({ 'aria-label': 'Mobile' });
    $('[role="navigation"][aria-label="Primary"], nav[aria-label="Primary"]').not('#NavDrawer *').slice(1).each(function () {
      rmAttr(this, 'role'); rmAttr(this, 'aria-label');
    });
  })();

  /* ========================================================================
     A11Y-096  Escape in the filter drawer applied the price filter and
     reloaded. Escape closes without applying; only "Apply filters" submits.
     ====================================================================== */
  (function fix096() {
    var $drawer = $('#FilterDrawer');
    if (!$drawer.length) { return; }
    var allow = false;
    $drawer.find('form').first().on('submit.abc096', function (e) {
      if (!allow) { e.preventDefault(); e.stopImmediatePropagation(); return false; }
    });
    $drawer.on('click.abc096', 'button', function () { if (/apply filters/i.test($(this).text())) { allow = true; } });
    $drawer.on('keydown.abc096', function (e) {
      if (e.key !== 'Escape') { return; }
      e.preventDefault(); e.stopImmediatePropagation();
      allow = false;
      $drawer.find('.drawer__close-button, [aria-label="Close Filter"]').first().trigger('click');
      setTimeout(function () { $('#FilterDrawerTrigger').trigger('focus'); }, 50);
    });
  })();

  /* ========================================================================
     A11Y-102  Two thumbnail labelling schemes with different counts.
     ====================================================================== */
  (function fix102() {
    var $t = $('.product__thumb-item a'), total = $t.length;
    $t.each(function (i) {
      var alt = $.trim($(this).find('img').attr('alt') || '').replace(/--American Bench Craft.*$/i, '').replace(/[_-]+/g, ' ');
      setAttr(this, 'aria-label', 'View product image ' + (i + 1) + ' of ' + total + (alt ? ': ' + alt : ''));
      setAttr($(this).find('img')[0], 'alt', '');
    });
  })();

  /* ========================================================================
     A11Y-106  Cart drawer "Add discount" and Checkout+ info not focusable.
     ====================================================================== */
  (function fix106() {
    function promote(el, label) {
      if (!el || el.hasAttribute('data-abc-btn')) { return; }
      $(el).abcAttr({ role: 'button', tabindex: '0', 'aria-label': label, 'data-abc-btn': '1' })
        .on('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $(this).trigger('click'); } });
    }
    watch('106', document.body, { childList: true, subtree: true }, function () {
      var $d = $(CART_DIALOG);
      if (!$d.length) { return; }
      promote($d.find('*').filter(function () { return this.children.length === 0 && /^Add discount$/i.test($.trim(this.textContent)); })
        .closest('.builder-block')[0], 'Add discount code');
      var $lbl = $d.find('*').filter(function () { return this.children.length === 0 && /^Checkout\+$/i.test($.trim(this.textContent)); }).first();
      promote($lbl.siblings().filter(function () { return $(this).find('svg').length; })[0], 'More information about Checkout+ returns and exchanges');
    });
  })();

  /* ========================================================================
     A11Y-112  Cart page quantity inputs all labelled "Quantity".
     ====================================================================== */
  (function fix112() {
    if (location.pathname !== '/cart') { return; }
    $('input[name^="updates"], .cart__qty input, input[id^="updates_"]').each(function () {
      var $row = $(this).closest('.cart__row, tr, .cart__item, [data-cart-item]');
      var title = $.trim($row.find('.cart__product-name, .cart__item-title, a[href*="/products/"]').first().text());
      if (!title) { return; }
      setAttr(this, 'aria-label', 'Quantity for ' + title);
      $row.find('button[aria-label*="item quantity by one"]').each(function () {
        setAttr(this, 'aria-label', this.getAttribute('aria-label').replace(/item quantity/i, 'quantity of ' + title));
      });
    });
  })();

  /* ========================================================================
     A11Y-114  Predictive search: nested listboxes; products/collections not
     reachable by arrow keys. Capture-phase handler so it runs before (and
     instead of) the older arrow-key handler.
     ====================================================================== */
  (function fix114() {
    var input = document.getElementById('Search'), wrap = document.getElementById('predictive-search-results');
    if (!input || !wrap) { return; }
    watch('114', wrap, { childList: true, subtree: true }, function () {
      $(wrap).find('[role="listbox"]').each(function () { setAttr(this, 'role', 'group'); });
      $(wrap).abcAttr({ role: 'listbox', 'aria-label': 'Search suggestions' });
      $(wrap).find('a[href]').each(function (i) {
        var li = $(this).closest('li')[0];
        if (li) { setAttr(li, 'role', 'presentation'); }
        if (!this.id) { this.id = 'abc-ps-opt-' + i; }
        setAttr(this, 'role', 'option');
        setAttr(this, 'tabindex', '-1');
        if (!this.hasAttribute('aria-selected')) { this.setAttribute('aria-selected', 'false'); }
      });
      setAttr(input, 'aria-expanded', $(wrap).find('[role="option"]').length ? 'true' : 'false');
    });
    var p = document.getElementById('predictive-search');
    if (p && p !== wrap) { rmAttr(p, 'role'); }
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') { return; }
      var $opts = $(wrap).find('[role="option"]').filter(function () { return this.offsetParent !== null; });
      if (!$opts.length) { return; }
      var idx = $opts.index($opts.filter('[aria-selected="true"]'));
      if (e.key === 'Enter') {
        if (idx > -1) { e.preventDefault(); e.stopImmediatePropagation(); $opts[idx].click(); }
        return;
      }
      e.preventDefault(); e.stopImmediatePropagation();
      idx = e.key === 'ArrowDown' ? (idx + 1) % $opts.length : (idx <= 0 ? $opts.length : idx) - 1;
      $opts.each(function (k) { setAttr(this, 'aria-selected', k === idx ? 'true' : 'false'); $(this).toggleClass('a11y-active', k === idx); });
      setAttr(input, 'aria-activedescendant', $opts[idx].id);
      $opts[idx].scrollIntoView({ block: 'nearest' });
    }, true);
  })();

  /* ========================================================================
     A11Y-123  Hero slide changes never announced; slides unnamed.
     ====================================================================== */
  (function fix123() {
    var $hero = $('.hero.flickity-enabled, .slideshow-wrapper .flickity-enabled').first();
    if (!$hero.length) { return; }
    var $slides = $hero.find('.slideshow__slide, .hero__slide');
    $hero.abcAttr({ role: 'region', 'aria-roledescription': 'carousel', 'aria-label': 'Featured collections' });
    $slides.each(function (i) {
      var title = $.trim($(this).find('h2, .hero__title, .h1').first().text()) || 'Slide ' + (i + 1);
      $(this).abcAttr({ role: 'group', 'aria-roledescription': 'slide', 'aria-label': 'Slide ' + (i + 1) + ' of ' + $slides.length + ': ' + title });
    });
    var last = '';
    function announceCurrent() {
      var label = $hero.find('.is-selected').first().attr('aria-label');
      if (label && label !== last) { last = label; window.announce(label); }
    }
    $hero.on('change.flickity settle.flickity', announceCurrent);
    $hero.find('.flickity-button').on('click.abc123', function () { setTimeout(announceCurrent, 400); });
  })();

  /* ========================================================================
     A11Y-135  Add to cart never completes (UpCart loader). Watchdog: if the
     loader is still showing after 8 s and the count has not changed, report
     the failure accessibly. NOTE: in testing Shopify returned HTTP 422 for
     this browser session; that is a store-side refusal JS cannot fix.
     ====================================================================== */
  (function fix135() {
    var $form = $('form[action*="/cart/add"]').first();
    var $btn = $form.find('button[name="add"], .add-to-cart').first();
    if (!$form.length || !$btn.length) { return; }
    var $status = $('#a11y-atc-status');
    if (!$status.length) { $status = $('<div id="a11y-atc-status" role="alert" class="visually-hidden"></div>').insertAfter($btn); }
    function count() { return $.getJSON('/cart.js').then(function (c) { return c.item_count; }); }
    function restore() { $btn.removeClass('with-upez-loader is-loading btn--loading').prop('disabled', false); setAttr($btn[0], 'aria-busy', 'false'); }
    $btn.on('keydown.abc135', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $(this).trigger('click'); }
    });
    $btn.on('click.abc135', function () {
      setAttr($btn[0], 'aria-busy', 'true');
      $status.text('');
      count().then(function (before) {
        setTimeout(function () {
          count().then(function (after) {
            if (after > before) { restore(); return; }
            $.ajax({ type: 'POST', url: '/cart/add.js', data: $form.serialize(), dataType: 'json' })
              .done(function (item) {
                restore();
                window.announce(((item && item.product_title) || $.trim($('h1').first().text())) + ' added to cart.');
                $('a[href*="/cart"].js-drawer-open').first().trigger('click');
              })
              .fail(function (xhr) {
                restore();
                var msg = (xhr.responseJSON && (xhr.responseJSON.description || xhr.responseJSON.message)) || 'Sorry, this item could not be added to the cart. Please try again.';
                $status.removeClass('visually-hidden').addClass('form-message form-message--error').text(msg);
                setAttr($status[0], 'tabindex', '-1');
                $status.trigger('focus');
              });
          });
        }, 8000);
      });
    });
  })();

  /* ========================================================================
     A11Y-136  Search results page: duplicate id="Search" breaks the label.
     ====================================================================== */
  (function fix136() {
    if (!/^\/search/.test(location.pathname)) { return; }
    var $main = $('#MainContent form input[name="q"], main form[action="/search"] input[name="q"]').first();
    if (!$main.length) { return; }
    $main.attr('id', 'SearchResultsInput');
    var $lbl = $main.closest('form').find('label[for="Search"]');
    if ($lbl.length) { $lbl.attr('for', 'SearchResultsInput'); }
    else if (!$main.closest('form').find('label[for="SearchResultsInput"]').length) {
      $('<label class="visually-hidden" for="SearchResultsInput">Search</label>').insertBefore($main);
    }
    rmAttr($main[0], 'aria-owns'); rmAttr($main[0], 'aria-controls');
  })();

  /* ========================================================================
     A11Y-137  Create Account: autocomplete, required, errors.
     ====================================================================== */
  (function fix137() {
    var $form = $('#create_customer, form[action="/account"]').first();
    if (!$form.length) { return; }
    $.each({ 'customer[first_name]': 'given-name', 'customer[last_name]': 'family-name', 'customer[email]': 'email', 'customer[password]': 'new-password' }, function (name, ac) {
      var $i = $form.find('[name="' + name + '"]');
      if (!$i.length) { return; }
      $i.abcAttr({ autocomplete: ac, required: 'required', 'aria-required': 'true' });
      var $l = $('label[for="' + $i.attr('id') + '"]');
      if ($l.length && !/\*/.test($l.text())) { $l.append(' <span aria-hidden="true">*</span><span class="visually-hidden"> (required)</span>'); }
    });
    var $pwd = $form.find('[name="customer[password]"]');
    if ($pwd.length && !document.getElementById('a11y-pwd-hint')) {
      $('<p id="a11y-pwd-hint" class="form__hint">Password must be at least 5 characters.</p>').insertAfter($pwd);
      setAttr($pwd[0], 'aria-describedby', 'a11y-pwd-hint');
    }
    if (!$form.find('.a11y-required-legend').length) {
      $form.prepend('<p class="a11y-required-legend">Fields marked <span aria-hidden="true">*</span><span class="visually-hidden">with an asterisk</span> are required.</p>');
    }
    var $err = $form.find('.errors, .form-message--error').first();
    if ($err.length && $.trim($err.text())) {
      if (!$err.attr('id')) { $err.attr('id', 'a11y-register-errors'); }
      $err.abcAttr({ role: 'alert', tabindex: '-1' });
      setTimeout(function () { $err.trigger('focus'); }, 50);
    }
  })();

  /* ========================================================================
     A11Y-138  404 "Popular picks" shows "Example product" placeholders.
     ====================================================================== */
  (function fix138() {
    if (!$('body').hasClass('template-404')) { return; }
    $('.grid-product').filter(function () { return /example product/i.test($(this).text()); })
      .closest('[id^="shopify-section-"]').each(function () {
        var $cards = $(this).find('.grid-product');
        if ($cards.length && !$cards.filter(function () { return !/example product/i.test($(this).text()); }).length) {
          setAttr(this, 'aria-hidden', 'true');
          $(this).addClass('abc-hidden-empty');
        }
      });
  })();

  /* ========================================================================
     A11Y-139  Bracelet size guide image: alt="" and no text equivalent.
     TODO (client): confirm the ranges against the graphic before publishing.
     ====================================================================== */
  (function fix139() {
    var $img = $('img[src*="Bracelets_Size_Guide"], img[data-src*="Bracelets_Size_Guide"]').first();
    if (!$img.length || $('.a11y-size-guide-text').length) { return; }
    setAttr($img[0], 'alt', 'Bracelet size guide');
    ($img.closest('a').length ? $img.closest('a') : $img).after(
      '<div class="a11y-size-guide-text"><p><strong>Bracelet size guide.</strong> Measure your wrist snugly with a soft tape measure where you will wear the bracelet. ' +
      'Small fits wrists 6 to 6.5 inches, Medium fits 6.5 to 7.25 inches, Large fits 7.25 to 8 inches. If you are between sizes, choose the larger size.</p></div>');
  })();

  /* ========================================================================
     A11Y-141  "Personalize It" reveal not announced / focus not moved.
     Bounded polling after the change – no observer.
     ====================================================================== */
  (function fix141() {
    $('select.js-cust-prod-options-upsell').each(function () {
      var $sel = $(this);
      var $cond = $('input[id^="' + this.id + '-condi"], textarea[id^="' + this.id + '-condi"]').first();
      if (!$cond.length) { return; }
      var $wrap = $cond.closest('div');
      if (!$wrap.attr('id')) { $wrap.attr('id', this.id + '-conditional-wrap'); }
      setAttr(this, 'aria-controls', $wrap.attr('id'));
      var last = $cond.is(':visible');
      setAttr(this, 'aria-expanded', last ? 'true' : 'false');
      $sel.on('change.abc141', function () {
        var n = 0;
        var t = setInterval(function () {
          var now = $cond.is(':visible');
          setAttr($sel[0], 'aria-expanded', now ? 'true' : 'false');
          if (now !== last) {
            last = now;
            clearInterval(t);
            if (now) {
              var label = $.trim($('label[for="' + $cond.attr('id') + '"]').text()).replace(/\d+\s*\|\s*\d+/, '').replace(/\*?\s*\(required\)|\*$/, '').trim();
              var price = ($sel.find('option:selected').text().match(/\[\+\s*([^\]]+)\]/) || [])[1];
              window.announce(label + ' field added, required.' + (price ? ' Adds ' + price + ' to the price.' : ''));
              setTimeout(function () { $cond.trigger('focus'); }, 150);
            } else {
              window.announce('Personalization removed.');
            }
          }
          if (++n > 12) { clearInterval(t); }
        }, 150);
      });
    });
  })();

  /* ========================================================================
     A11Y-142  Character counter ("0 | 24") inside the <label>.
     ====================================================================== */
  (function fix142() {
    $('label[for]').each(function () {
      var inputId = this.getAttribute('for');
      var $counter = $(this).find('*').filter(function () { return /^\s*\d+\s*\|\s*\d+\s*$/.test($(this).text()); }).last();
      var $i = $('#' + inputId.replace(/([^\w-])/g, '\\$1'));
      if (!$counter.length || !$i.length) { return; }
      var cid = inputId + '-count';
      $counter.attr('id', cid).abcAttr({ role: 'status', 'aria-live': 'polite', 'aria-atomic': 'true' }).insertAfter($i);
      var db = ($i.attr('aria-describedby') || '').split(/\s+/).filter(Boolean);
      if (db.indexOf(cid) === -1) { db.push(cid); setAttr($i[0], 'aria-describedby', db.join(' ')); }
      var t;
      $i.on('input.abc142', function () {
        setAttr($counter[0], 'aria-live', 'off');
        clearTimeout(t);
        t = setTimeout(function () { setAttr($counter[0], 'aria-live', 'polite'); }, 1200);
      });
    });
  })();

  /* ========================================================================
     A11Y-144  Gallery slides with alt="" (lazy-loaded). Thumbnails excluded –
     their links carry the label (A11Y-102).
     ====================================================================== */
  (function fix144() {
    var gallery = document.querySelector('.product__photos, .product-slideshow');
    if (!gallery) { return; }
    var title = $.trim($('.product-single__title, h1').first().text());
    watch('144', gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['alt', 'src'] }, function () {
      var $imgs = $(gallery).find('img').not('.product__thumb-item img');
      $imgs.each(function (i) {
        if (!$.trim(this.getAttribute('alt') || '')) { setAttr(this, 'alt', title + ' – image ' + (i + 1) + ' of ' + $imgs.length); }
      });
    });
  })();

  /* ========================================================================
     A11Y-145  Generic / filename alt text on informative images.
     ====================================================================== */
  (function fix145() {
    var byAlt = {
      'Product Badges': 'Made in USA, Bench Craft Guarantee, Premium Full Grain Leather',
      'Corporate Gift Slider Photo': 'Leather corporate gifts with custom logos: belts, wallets and key fobs'
    };
    var bySrc = {
      'MonogramInfograph-HammerRivetedWallet': 'Monogram placement on the Hammer Riveted Wallet: up to five initials heat-embossed in the lower right corner of the front panel',
      'Monogram_Infograph_-_Working_Man_s_Belt': 'Monogram placement on the Working Man\'s Belt: up to five initials heat-embossed on the tail end of the belt'
    };
    $('img').each(function () {
      var alt = $.trim(this.getAttribute('alt') || ''), src = this.getAttribute('src') || this.getAttribute('data-src') || '';
      if (byAlt[alt]) { setAttr(this, 'alt', byAlt[alt]); return; }
      for (var k in bySrc) { if (src.indexOf(k) > -1 || alt === k) { setAttr(this, 'alt', bySrc[k]); return; } }
    });
  })();

  /* ========================================================================
     A11Y-146  Empty headings.
     ====================================================================== */
  (function fix146() {
    $('h1,h2,h3,h4,h5,h6').filter(function () {
      return !$.trim($(this).text()) && !$(this).find('img[alt]').filter(function () { return $.trim(this.alt); }).length;
    }).remove();
  })();

  /* ========================================================================
     A11Y-147  Register Your Product: H1>H3 skip; Name not required.
     (Old version re-wrote "required" on every "required" change = loop.)
     ====================================================================== */
  (function fix147() {
    if (location.pathname !== '/pages/register') { return; }
    setHeadingLevel($('#MainContent h3').filter(function () { return /fill out the form/i.test($(this).text()); }), 2);
    var name = document.querySelector('input[name="contact[name]"]');
    if (!name) { return; }
    watch('147', name, { attributes: true, attributeFilter: ['required', 'aria-required'] }, function () {
      setAttr(name, 'required', 'required');
      setAttr(name, 'aria-required', 'true');
    });
    var $l = $('label[for="' + name.id + '"]');
    if ($l.length && !/\(required\)/.test($l.text())) { $l.append('<span class="visually-hidden"> (required)</span>'); }
  })();

  /* ========================================================================
     A11Y-148  Military Discounts headings.
     ====================================================================== */
  (function fix148() {
    if (location.pathname !== '/pages/military-discounts') { return; }
    $('#MainContent *').filter(function () {
      return this.children.length === 0 && /^how to receive your discount/i.test($.trim($(this).text())) && !/^H[1-6]$/.test(this.tagName);
    }).first().each(function () {
      var $h = $('<h2>').attr('class', this.className).text($.trim($(this).text()));
      var $p = $(this).closest('p, div');
      ($p.length && $p.children().length <= 1 ? $p : $(this)).replaceWith($h);
    });
    var $first = $('#MainContent h3').first();
    if ($first.length && !$first.prevAll('h2').length && !document.getElementById('a11y-stories-heading')) {
      var $sec = $first.closest('[id^="shopify-section-"], section, .page-width');
      ($sec.length ? $sec : $first.parent()).prepend('<h2 id="a11y-stories-heading" class="visually-hidden">What our military and first responder customers say</h2>');
    }
  })();

  /* ========================================================================
     A11Y-149  Junip review titles and testimonial titles as <h4>.
     ====================================================================== */
  (function fix149() {
    var onReviews = location.pathname === '/pages/reviews';
    setHeadingLevel($('.testimonials-slide h4, .testimonials-slider__title').filter(function () { return /^H[1-6]$/.test(this.tagName); }), onReviews ? 2 : 3);
    watch('149', document.body, { childList: true, subtree: true }, function () {
      var $t = $('h4.junip-review-title, h4[class*="junip-review-title"]');
      if ($t.length) { setHeadingLevel($t, onReviews ? 2 : 3); }
    });
  })();

  /* ========================================================================
     A11Y-150  Article table has no <th>.
     ====================================================================== */
  (function fix150() {
    $('article table, .rte table, .article__body table').each(function () {
      var $t = $(this);
      if ($t.find('th').length) { return; }
      var $rows = $t.find('tr');
      $rows.first().find('td').replaceWith(function () { return '<th scope="col">' + $(this).html() + '</th>'; });
      $rows.slice(1).each(function () { $(this).find('td').first().replaceWith(function () { return '<th scope="row">' + $(this).html() + '</th>'; }); });
      if (!$t.find('thead').length) { $t.prepend($('<thead>').append($t.find('tr').first())); }
    });
  })();

  /* ========================================================================
     A11Y-151 / A11Y-152 / A11Y-121  Target sizes – CSS only.
     ====================================================================== */

  /* ========================================================================
     A11Y-153  Klaviyo teaser: unnamed; must hide only while a drawer/dialog
     is really open. Uses its OWN body class (abc-overlay-open) so it can
     never fight a leftover "a11y-dialog-open" toggler. Watches the drawer
     elements themselves and body's own class – never the body subtree.
     ====================================================================== */
  (function fix153() {
    var CLS = 'abc-overlay-open';
    function anyOpen() {
      if (document.body.classList.contains('js-drawer-open')) { return true; }
      if (document.querySelector('.drawer.is-active, .site-header__search-container.is-active')) { return true; }
      return inViewport(document.querySelector(CART_DIALOG)) || inViewport(document.querySelector('.junip-modal'));
    }
    var pending = false;
    function sync() {
      pending = false;
      var open = anyOpen();
      if (document.body.classList.contains(CLS) !== open) { document.body.classList.toggle(CLS, open); }
    }
    function schedule() { if (!pending) { pending = true; raf(sync); } }
    var targets = [document.body, document.getElementById('NavDrawer'), document.getElementById('FilterDrawer'),
                   document.querySelector('.site-header__search-container')];
    var mo = new MutationObserver(schedule);
    targets.forEach(function (t) { if (t) { mo.observe(t, { attributes: true, attributeFilter: ['class'] }); } });
    // Builder.io cart drawer and Junip modal render late – attach when they appear.
    var attached = {};
    watch('153-attach', document.body, { childList: true, subtree: true }, function () {
      [CART_DIALOG, '.junip-modal'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el && attached[sel] !== el) { attached[sel] = el; mo.observe(el, { attributes: true, attributeFilter: ['class', 'style'] }); schedule(); }
      });
      $('[class*="Teaser-pointer"][role="button"]').each(function () {
        if (!this.getAttribute('aria-label')) { setAttr(this, 'aria-label', 'Open sign-up form, ' + ($.trim($(this).text()) || '10% off')); }
      });
    });
    document.addEventListener('transitionend', schedule, true);
    $(window).on('resize.abc153', schedule);
    $(document).on('click.abc153 keyup.abc153', function () { setTimeout(schedule, 350); });
    schedule();
  })();

  /* ========================================================================
     A11Y-154  Identical "YouTube video player" iframe titles.
     TODO (client): confirm titles match the videos.
     ====================================================================== */
  (function fix154() {
    var byId = { 'UqM7OuF58us': 'Video: Leatherman sheath review', 'vEaIq55eL_g': 'Video: multi-tool sheath comparison' };
    $('iframe[src*="youtube.com/embed/"]').each(function (i) {
      var id = (this.src.match(/embed\/([^?&\/]+)/) || [])[1];
      var $h = $(this).prevAll('h2,h3').first();
      setAttr(this, 'title', byId[id] || ('Video: ' + ($h.length ? $.trim($h.text()) : 'YouTube video ' + (i + 1))));
    });
  })();

  /* ========================================================================
     A11Y-155 / A11Y-061  mailto href / visible text mismatch; tel label.
     ====================================================================== */
  (function fix155() {
    $('a[href^="mailto:"]').each(function () {
      var visible = $.trim($(this).text()).replace(/\.$/, '');
      if (/^[\w.+-]+@[\w-]+\.[\w.]+$/.test(visible)) { setAttr(this, 'href', 'mailto:' + visible); }
      setAttr(this, 'aria-label', 'Email Address: ' + this.getAttribute('href').replace(/^mailto:/i, '').split('?')[0]);
    });
    $('a[href^="tel:"]').each(function () {
      setAttr(this, 'aria-label', 'Phone Number: ' + $.trim($(this).text()).replace(/\.$/, ''));
    });
  })();

  /* ========================================================================
     A11Y-156  Testimonial star ratings are plain ★ characters.
     ====================================================================== */
  (function fix156() {
    $('.testimonial-stars').each(function () {
      var filled = ($(this).text().match(/★/g) || []).length;
      var total = ($(this).text().match(/[★☆]/g) || []).length || 5;
      $(this).abcAttr({ role: 'img', 'aria-label': 'Rated ' + filled + ' out of ' + total + ' stars' });
    });
  })();

  /* ========================================================================
     A11Y-157  Accessibility statement link (added once the page exists).
     ====================================================================== */
  (function fix157() {
    if ($('footer a[href="/pages/accessibility-statement"]').length) { return; }
    var $support = $('footer a[href="/pages/contact"]').closest('ul');
    if (!$support.length) { return; }
    $.ajax({ type: 'HEAD', url: '/pages/accessibility-statement' }).done(function () {
      $support.append('<li><a href="/pages/accessibility-statement" class="' + ($support.find('a').first().attr('class') || '') + '">Accessibility Statement</a></li>');
    });
  })();

})(window.jQuery);